import { render, staticRenderFns } from "./ConsultaHistorico.vue?vue&type=template&id=13ec9445&"
import script from "./ConsultaHistorico.vue?vue&type=script&lang=js&"
export * from "./ConsultaHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports